var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"vbtn",attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('lserv-icon',{attrs:{"name":"more_vert"}})],1)]}}])},[_vm._v(" "),_c('menu-items',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }